exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header {\r\n    color: white;\r\n    background-color: #171514;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/step-confirm-popup/step-confirm-popup.component.css
// module id = ../../../../../src/app/content-page/admin/create-operating-standard/step-confirm-popup/step-confirm-popup.component.css
// module chunks = main